import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrMR: CultureInfo = {
  name: 'fr-MR',
  displayName: 'français (Mauritanie)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-MR',
  parent: CultureInfoFr
};
